'use strict';

import { Buildings, projectMode, settingsData, threeJsVariables } from '../../../settings';
import { Box3, Group, Vector3 } from 'three';
import { ViewMode } from '../../../common';
import { getCurrentCameraDistance } from '../../controls/orbitControls';
import {CSS2DObject} from "../../../libs/CSS2DRenderer";
import {changeLangToCurrent, getCurrentLang} from "../langSwitcher/langSwitcher";
import { intersectionClickHandler } from '../../threejs/raycast';
import {setCSSVar} from "../../../functions";
import {BaseElement} from "../../interfaces/BaseElement";

/* Old version */

export const flatLabels = ({currentFloor, location}) => {
    const activeBuilding = Buildings.getActiveBuilding();
    const floor = activeBuilding.getFloorSelections(currentFloor);
    const scene = threeJsVariables.scene;
    const flaLabelsGroup = new Group();
    flaLabelsGroup.name = 'flaLabelsGroup';

    const flatLabelsTextColor = config.threejs?.flatLabels?.textColor;
    if(flatLabelsTextColor)
        setCSSVar('--flatLabelsTextColor', flatLabelsTextColor);

    const box = new Box3();
    const size = new Vector3();

    for (const apartment of floor) {
        const isPlug = apartment.name.toLowerCase().startsWith(config.resources.bundle.selectionBoxes.floorPlugName)
        if (apartment.name.match(/(amenity)|(Loby)|(lobby)|(Roof)|(roof)/g) || !apartment.userData.crm_data && !isPlug)
            continue;

        let flatLabelContainer;
        let flatLabel;
        const center = apartment.getWorldPosition(new Vector3());
        box.setFromObject(apartment).getSize(size);


        //Apartment
        if (!isPlug){
            flatLabelContainer = getHtml({apartment, type: 'apt', location});
            flatLabel = new CSS2DObject(flatLabelContainer);
            flatLabel.element.setAttribute('data-apartment-name',apartment.name);
            flatLabel.element.onclick = (e) => apartmentLabelHandler(e.target);
        } else {
            flatLabelContainer = getHtml({apartment, type: 'plug'});
            projectMode.FloorPlan.floorAmenities.addIcon(flatLabelContainer,apartment);
            flatLabel = new CSS2DObject(flatLabelContainer);
        }
        flatLabel.userData.zoom = config.threejs.flatLabels.resize ? 1.0 : config.threejs.flatLabels.size;
        flatLabel.name = `floor-label`;
        flatLabel.position.set(center.x, center.y + size.y, center.z);
        flaLabelsGroup.add(flatLabel);
    }
    scene.add(flaLabelsGroup);
}

export function flatLabelPictureLiteMode (apartment) {
    const flatLabelContainer = getHtml({apartment, type: 'apt'});
    flatLabelContainer.classList.add('picture-mode');
    const flatLabel = new CSS2DObject(flatLabelContainer);
    flatLabel.element.setAttribute('data-apartment-name',apartment.name);
    flatLabel.element.onclick = (e) => apartmentLabelHandler(e.target);
    flatLabel.userData.zoom = 1.0;
    flatLabel.name = `label`;

    apartment.add(flatLabel);
    return flatLabel;
}

/* New version */

// export const flatLabels = (currentFloor) => {
//
//     const activeBuilding = Buildings.getActiveBuilding();
//     const floor = activeBuilding.getFloorSelections(currentFloor);
//
//     // const scene = threeJsVariables.scene;
//     // const flaLabelsGroup = new THREE.Group();
//     // flaLabelsGroup.name = 'flaLabelsGroup';
//
//     for (const apartment of floor) {
//
//         if (apartment.name.match(/(amenity)|(Loby)|(lobby)|(Roof)|(roof)/g)) continue;
//
//         let flatLabelContainer;
//         let flatLabel;
//
//         //Apartment
//         if (!apartment.name.toLowerCase().startsWith(config.resources.bundle.selectionBoxes.floorPlugName)){
//
//             flatLabelContainer = getHtml(apartment, 'apt');
//
//             flatLabel = new CSS2DObject(flatLabelContainer);
//             flatLabel.element.setAttribute('data-apartment-name',apartment.name);
//             flatLabel.element.onclick = (e) => apartmentLabelHandler(e.target);
//         } else {
//
//             flatLabelContainer = getHtml(apartment, 'plug');
//             flatLabel = new CSS2DObject(flatLabelContainer);
//         }
//
//         flatLabel.userData.zoom = 0.1;
//         flatLabel.name = `floor-label`;
//
//         // flaLabelsGroup.add(flatLabel);
//         apartment.add(flatLabel);
//
//     }
//
//     // scene.add(flaLabelsGroup);
// }

function apartmentLabelHandler (target) {
    const flatContainer = target.closest('.flat-label-container');
    const aptName = flatContainer.getAttribute('data-apartment-name');
    const apt = threeJsVariables.scene.getObjectByName(aptName);
    intersectionClickHandler(apt);
}

export const flatLabelsRemove = () => {

    /* New Version */

    // const activeBuilding = Buildings.getActiveBuilding();
    //
    // activeBuilding.selectionsGroup.traverse(el =>{
    //    if (el.name === 'floor-label'){
    //        el.removeFromParent();
    //    }
    // });


   /* Old version */
    const scene = threeJsVariables.scene;
    if (scene.getObjectByName('flaLabelsGroup')) {
        const groupToRemove = scene.getObjectByName('flaLabelsGroup');
        scene.remove(groupToRemove);

        const labels = document.querySelectorAll('.flat-label-container');
        labels.forEach(item => {
            item.remove();
        });
    }
}

export function flatLabelPositionChange(position) {
    const scene = threeJsVariables.scene;
    if (scene.getObjectByName('flaLabelsGroup')) {
        const groupToPositionSet = scene.getObjectByName('flaLabelsGroup');
        groupToPositionSet.position.x += position.x;
        groupToPositionSet.position.y += position.y;
        groupToPositionSet.position.z += position.z;

        // const labels = document.querySelectorAll('.flat-label-container');
        // labels.forEach(item => {
        //     item.remove();
        // });
    }
}

export function flatLabelResize () {
   if (settingsData.activeViewMode === ViewMode.FloorPlan && config.threejs.flatLabels.resize){

       /* New version */
       // const currentCameraDistance = getCurrentCameraDistance();
       // const zoom = 1 / currentCameraDistance * 100 - 0.65;
       //
       // const activeBuilding = Buildings.getActiveBuilding();
       //
       // activeBuilding.selectionsGroup.traverse(el =>{
       //    if (el.name === 'floor-label'){
       //        el.userData.zoom = zoom > 1 ? 1 : zoom;
       //    }
       // });

      /* Old version */
       const labelsGroup = threeJsVariables.scene.getObjectByName('flaLabelsGroup');
       if (labelsGroup){
           const currentCameraDistance = getCurrentCameraDistance();
           const distance = config.threejs.flatLabels.size - currentCameraDistance * (config.threejs.flatLabels.size / 2) / threeJsVariables.orbitControls.maxDistance;
           const zoom = Math.max( config.threejs.flatLabels.size / 2, Math.min( config.threejs.flatLabels.size, distance ));

           labelsGroup.traverse(label =>{
               if (label.type === 'Object3D')
                   label.userData.zoom = zoom;
           });
       }
   }
}
// export const flatLabelsUpdate = (currentFloor) => {
//     flatLabelsRemove();
//     flatLabels(currentFloor);
// }

function getHtml({apartment, type, location}) {
    const flatLabelContainer = document.createElement('div');
    flatLabelContainer.className = 'flat-label-container';
    // const clickedApartment = settingsData.lastClickedFlat;
    const pointClasses = ['flat-label--point'];
    const icon360Classes = ['flat-label--icon'];
    let subTitleInfo;

    switch (type) {
        case 'apt':
            const crm = apartment.userData?.crm_data;
            if (!crm)
                return;

            if (crm.status.toLowerCase() !== 'available') {
                pointClasses.push('unavailable');
                subTitleInfo = changeLangToCurrent(crm.status);
            } else {
                pointClasses.push('available');
                subTitleInfo = location === 'cylinder' ? '' : crm.modelName;
            }

            if (crm.assets.tours360 && location !== 'cylinder')
                icon360Classes.push('icon-360');
            if (apartment.userData.favorite)
                pointClasses.push('in-favorite');


            const isHiddenSubtitle = config.threejs.flatLabels?.hideSubtitle;
            const flatLabelSubtitleDataDictionary =
                isHiddenSubtitle
                    ? ''
                    : crm.status === 'Available' ? subTitleInfo : crm.status;
            const subtitleInnerHtml = isHiddenSubtitle ? '' : subTitleInfo;
            flatLabelContainer.innerHTML = `
                <div class='flat-label' data-apartment="${crm.bmbyPropID}">
                    <div class="${pointClasses.join(' ')}">
                        <div class="flat-label-text">
                            <h1 class="flat-label--title">${crm.propNum}</h1>
                            <h2 class="flat-label--subtitle language-string" data-dictionary="${flatLabelSubtitleDataDictionary}">${subtitleInnerHtml}</h2>
                        </div>
                        <div class="flat-label-icon">
                            <span class="${icon360Classes.join(' ')}"></span>
                        </div>
                    </div>
                </div>`;

            if (location === 'cylinder') {
                const flatLabelText = flatLabelContainer.querySelector('.flat-label--title');
                flatLabelText.classList.add('font-normal');
            }

            break;
        case 'plug':
            let element = `
                <div class="flat-label-center">
                    <div class="flat-label__content-wrapper">
                        <span class="language-string flat-label-center--title" data-dictionary="floor">${changeLangToCurrent('floor')}</span>
                        <span class="flat-label-center--number">${apartment.userData.floor}</span>
                    </div>
                    <div class="floor-amenities"></div>
                </div>`;

            const isGroundFloor = settingsData.groundFloor.isActive && (parseInt(settingsData.groundFloor.floor) === parseInt(apartment.userData.floor));
            if (isGroundFloor) {
                const fullLabel = settingsData.groundFloor.fullLabel;
                const groundFloor = new BaseElement()
                  .addClass('flat-label-center');
                const contentWrapper = new BaseElement()
                  .addClass('flat-label__content-wrapper')
                  .appendTo(groundFloor.DOMElement);
                new BaseElement()
                  .addClass('floor-amenities')
                  .appendTo(groundFloor.DOMElement);
                new BaseElement('span')
                  .addClass('language-string', 'flat-label-center--title')
                  .addAttribute(`data-dictionary`, fullLabel)
                  .innerHtml(changeLangToCurrent(fullLabel))
                  .appendTo(contentWrapper.DOMElement);
                element = groundFloor.DOMElement.outerHTML;
            }

            flatLabelContainer.innerHTML = element;
            break;
    }

    return flatLabelContainer;
}
